import * as React from "react";
import type { SVGProps } from "react";
const SvgCyclingIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <g clipPath="url(#cycling-icon_svg__a)">
      <path
        fill="#858585"
        d="M22.033 9.925c-.814 0-1.59.164-2.298.46l-1.691-3.282h2.364a.466.466 0 0 1 0 .93h-.504a.48.48 0 1 0 0 .961h.504c.787 0 1.427-.64 1.427-1.426 0-.787-.64-1.427-1.427-1.427h-3.153a.48.48 0 0 0-.427.701l.841 1.632h-6.938l-.7-1.371h1.107a.48.48 0 0 0 0-.962H7.985a.48.48 0 1 0 0 .962h.967l.934 1.83-1.098 1.702a5.9 5.9 0 0 0-2.82-.71A5.974 5.974 0 0 0 0 15.892a5.974 5.974 0 0 0 5.967 5.967 5.975 5.975 0 0 0 5.948-5.486h1.41l-.548 1.783h-.315a.48.48 0 1 0 0 .961h1.73a.48.48 0 1 0 0-.961h-.409l.633-2.059 4-6.174.466.904a5.97 5.97 0 0 0-2.816 5.065 5.974 5.974 0 0 0 5.967 5.967A5.974 5.974 0 0 0 28 15.892a5.974 5.974 0 0 0-5.967-5.967M10.39 9.924l2.8 5.487h-1.276a5.97 5.97 0 0 0-2.32-4.253zm.558 5.487h-4.1l2.222-3.442a5 5 0 0 1 1.878 3.442m-4.982 5.487a5.01 5.01 0 0 1-5.006-5.006 5.01 5.01 0 0 1 5.006-5.006c.828 0 1.609.203 2.297.56l-2.7 4.185a.48.48 0 0 0 .403.741h4.982a5.01 5.01 0 0 1-4.982 4.526m8.059-5.967-2.804-5.495h6.364zm8.007 5.967a5.01 5.01 0 0 1-5.006-5.006c0-1.763.917-3.314 2.297-4.206l2.282 4.426a.48.48 0 1 0 .854-.44l-2.282-4.428c.574-.23 1.2-.358 1.855-.358a5.01 5.01 0 0 1 5.006 5.006 5.01 5.01 0 0 1-5.006 5.006"
      />
    </g>
    <defs>
      <clipPath id="cycling-icon_svg__a">
        <path fill="#fff" d="M0 0h28v28H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCyclingIcon;
